/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const widget_android = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M1.333 2.413a.68.68 0 0 1 .681-.681H5.82a.68.68 0 0 1 .681.68V6.32a.68.68 0 0 1-.68.68H2.013a.68.68 0 0 1-.68-.68V2.413ZM9 4.559a.68.68 0 0 1 0-.963l2.441-2.441a.68.68 0 0 1 .963 0l2.44 2.441a.68.68 0 0 1 0 .963l-2.44 2.44a.68.68 0 0 1-.963 0L9 4.56ZM1.333 10.18a.68.68 0 0 1 .681-.68H5.82a.68.68 0 0 1 .681.68v3.806a.68.68 0 0 1-.68.68H2.013a.68.68 0 0 1-.68-.68V10.18Zm7.667 0a.68.68 0 0 1 .68-.68h3.907a.68.68 0 0 1 .68.68v3.806a.68.68 0 0 1-.68.68H9.681a.68.68 0 0 1-.681-.68V10.18Z"
    />
  </svg>
)
export default widget_android
